<template>
  <v-app>
    <v-container grid-list-md>
      <v-breadcrumbs
        large
        :items="items"
        divider=">"
      ></v-breadcrumbs>
      <v-layout justify-center>
        <v-dialog
          v-model="dialog"
          persistent
          max-width="600px"
        >
          <v-card>
            <v-card-title>
              <span class="headline">User Profile</span>
            </v-card-title>
            <v-card-text>
              <v-container grid-list-md>
                <v-layout wrap>

                  <v-flex xs12>
                    <v-text-field
                      v-model='user.email'
                      disabled
                      readonly
                      label="Email"
                      required
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12>
                    <v-text-field
                      v-model='user.name'
                      label="Name"
                      required
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12>
                    <v-text-field
                      v-model='user.phone'
                      label="Phone"
                      required
                    ></v-text-field>
                  </v-flex>
                </v-layout>
              </v-container>
              <small>*indicates required field</small>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                color="blue darken-1"
                text
                @click="dialog = false"
              >Close</v-btn>
              <v-btn
                color="blue darken-1"
                text
                @click="saveToDB(),dialog = false"
              >Save</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-layout>

      <v-layout row>
        <v-flex
          xs12
          sm6
          offset-xs3
        >
          <v-card color='primary'>
            <v-layout
              column
              fill-height
            >
              <v-card-title>

                <v-spacer></v-spacer>

                <v-btn
                  @click="dialog = true"
                  dark
                  icon
                  class="mr-3"
                >
                  <v-icon>edit</v-icon>
                </v-btn>

              </v-card-title>

              <v-spacer></v-spacer>

              <v-card-title class="white--text pl-5 pt-5">
                <div class="display-1 pl-5 pt-5">{{user.name}}</div>
              </v-card-title>
            </v-layout>

            <v-list two-line>
              <v-list-item>
                <v-list-item-action>
                  <v-icon color="indigo">phone</v-icon>
                </v-list-item-action>

                <v-list-item-content>
                  <v-list-item-title>{{user.phone}}</v-list-item-title>
                  <v-list-item-subtitle>Mobile</v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>

              <v-divider inset></v-divider>
              
              <v-list-item>
                <v-list-item-action>
                  <v-icon color="indigo">mail</v-icon>
                </v-list-item-action>
             
                <v-list-item-content>
                  <v-list-item-title>{{user.email}}</v-list-item-title>
                  <v-list-item-subtitle>Email</v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
              <v-divider inset></v-divider>
              <v-list-item>
                <v-list-item-action>
                  <v-icon color="indigo">lock</v-icon>
                </v-list-item-action>
             
                <v-list-item-content>
                   <v-list-item-content>
                  <v-list-item-title><resetPassword text='Password reset'/></v-list-item-title>
                </v-list-item-content>
                </v-list-item-content>
              </v-list-item>
            </v-list>
          </v-card>
        </v-flex>

        <v-flex
          mt-5
          xs12
          sm6
          offset-xs3
        >
          <template>
            <v-card
              :loading="loading"
              class="mx-auto"
            >
              <v-toolbar
                color="light-blue"
                dark
              >
                <v-toolbar-title>User Activity History</v-toolbar-title>

                <v-spacer></v-spacer>

                <v-btn
                  title='got questions?'
                  icon
                >
                  <v-icon>help</v-icon>
                </v-btn>
              </v-toolbar>

              <v-list
                two-line
                subheader
              >

                <v-list-item
                  v-for="(item,index) in files"
                  :key="index"
                  @click="openURL(item.fileURL)"
                >
                  <v-list-item-avatar>
                    <v-icon class="blue white--text">assignment</v-icon>
                  </v-list-item-avatar>

                  <v-list-item-content>
                    <v-list-item-title v-text="item.fileName"></v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </v-list>
            </v-card>
          </template>
        </v-flex>
      </v-layout>
    </v-container>
  </v-app>
</template>


<script>
import resetPassword from '../components/resetPasswordModal'
import { mapFields } from 'vuex-map-fields';
import { editUserData } from '../helper/firestore'
export default {
  components : {
    resetPassword
  },
  data () {
    return {
      items: [{
        text: 'Home',
        disabled: false,
        to: '/home'
      },
      {
        text: 'My Account',
        disabled: true,

      }
      ],
      dialog: false,
      files: null,
      loading: true,
    }
  },
  mounted () {
    this.readEntry()
  },
  methods: {
    openURL (url) {
      window.open(url);
    },
    readEntry () {
      this.files = [];
      const url = process.env.VUE_APP_ROOT_API_URL +'api/user/getfileDownloadURL'
      this.$axios
        .post(url, {
          headers: { "Content-Type": "application/json;charset=UTF-8" },
          data: { idToken: this.user.idToken, filesNames: ["Va1Cuoy5.pdf", "undefined (6).pdf"] }
        }).then((response) => {
          this.files = response.data
          this.loading = false
        }).catch(() => {

        })
    },
    saveToDB () {
      editUserData(this.user.idToken, this.user, () => {
        this.snackBarType = "success"
        this.snackBarshow = true
        this.snackBarmessage = "Update complete"
      })
    }
  },
  computed: {
    ...mapFields([
      'user',
      'snackBarshow',
      'snackBarType',
      'snackBarmessage',
    ]),
  }
}
</script>
